import Vue from "vue";
import vuetify from "../vuetify.js";
import depsloader from "../depsloader";
import SchadensmeldungApp from "../components/contact/SchadensmeldungApp.vue";

export default function() {
  const element = document.querySelector("#vue-schadensmeldung");

  if (element) {
    depsloader.load("vue-i18n").then((vueI18n) => {
      Vue.use(vueI18n.VueI18n);

      let vueArgs = {};

      vueArgs = {...vueArgs, ...{
        el: element,

        components: {
          SchadensmeldungApp
        },

        vuetify,
        i18n: new vueI18n.VueI18n(vueI18n.options),

        render: h => h(SchadensmeldungApp)
      }};

      new Vue(vueArgs)
    });
  }
}
